module.exports = __webpack_public_path__ + "fonts/Flaticon.woff?2ee2a6f38e347b175b7b0b93f084e84c";